import { useEffect } from 'react';
import { ViewerQueryParams } from '../constants';

const SCROLL_SETTLE_DELAY_MS = 1000;
const STABLE_FRAMES_TO_CONFIRM_IDLE = 3;

export function useOpenCartAfterScroll(shouldOpenCart?: boolean, openSideCart?: () => void) {
  useEffect(() => {
    if (!openSideCart || !shouldOpenCart) {
      return;
    }

    let hasCompleted = false;
    let pendingFrameId: number | null = null;

    const cancelPendingFrame = () => {
      if (pendingFrameId !== null) {
        cancelAnimationFrame(pendingFrameId);
        pendingFrameId = null;
      }
    };

    const openCartOnce = () => {
      if (hasCompleted) {
        return;
      }

      hasCompleted = true;
      cancelPendingFrame();
      openSideCart();

      if (window !== undefined) {
        const url = new URL(window.location.href);

        url.searchParams.delete(ViewerQueryParams.openSideCart);
        url.hash = '';
        window.history.replaceState(window.history.state, '', url.toString());
      }
    };

    const settleDelayTimer = setTimeout(() => {
      if (hasCompleted) {
        return;
      }

      let previousScrollY = window.scrollY;
      let stableFrameCount = 0;

      const watchScrollUntilIdle = () => {
        if (hasCompleted) {
          return;
        }

        const currentScrollY = window.scrollY;

        if (currentScrollY !== previousScrollY) {
          stableFrameCount = 0;
          previousScrollY = currentScrollY;
        } else {
          stableFrameCount += 1;

          if (stableFrameCount >= STABLE_FRAMES_TO_CONFIRM_IDLE) {
            openCartOnce();
            return;
          }
        }

        pendingFrameId = requestAnimationFrame(watchScrollUntilIdle);
      };

      pendingFrameId = requestAnimationFrame(watchScrollUntilIdle);
    }, SCROLL_SETTLE_DELAY_MS);

    return () => {
      hasCompleted = true;
      clearTimeout(settleDelayTimer);
      cancelPendingFrame();
    };
  }, [shouldOpenCart, openSideCart]);
}
